import {h, Fragment, Component} from "preact";
import {t, Trans} from "@lingui/macro"

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";

import SchedulesTimeFilter from "../utils/schedules-time-filter";

import * as M from "../desktop-templates/prematch-menu.jsx";
import AwrabetMenuFull, { SportRow as AwrabetSportRow, CategoryRow as AwrabetCategoryRow } from '../../awrabet/desktop-components/menu-full.jsx';

export default class MenuFull extends AwrabetMenuFull {
	render({onTournamentOpen}) {
		if (this.state.sports == null)
			return null;
		return <div class="overflow-hidden mt-3">
			{this.state.sports
				.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
				.map(sport => <SportRow key={sport.id} sport={sport} onTournamentOpen={onTournamentOpen} />)}
		</div>
	}
}

export class SportRow extends AwrabetSportRow {
	render({sport, onTournamentOpen}) {
		return <div>
			<M.SportButton active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				<M.MenuMatchCounter>{sport.count}</M.MenuMatchCounter>
				<M.CircleSeparator />
				<M.LeagueNameLabel>{sport.name}</M.LeagueNameLabel>
				<M.SportFlagIcon sport={sport} />
			</M.SportButton>
			{this.state.wasOpen && <div class={this.state.open ? "" : "hidden"}>
				{Object.values(sport.sub)
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.sort((a, b) => {
						if (!a.order) {
							a.order = 100000000;
						}
						if (!b.order) {
							b.order = 100000000;
						}
						if (a.order !== b.order) {
							return a.order - b.order
						}
						if (a.name < b.name) {
							return -1;
						}
						if (a.name > b.name) {
							return 1;
						}
						return 0;
					}).map(category => {
						return <CategoryRow key={category.id} category={category} onTournamentOpen={onTournamentOpen} />
					})
				}
			</div>}
		</div>
	}
}

export class CategoryRow extends AwrabetCategoryRow {
	render({category, onTournamentOpen}) {
		return <div>
			<M.CategoryButton active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				<M.CircleSeparatorW2 />
				<M.RegionFlag category={category} />
				<M.LeagueNameLabel>{category.name}</M.LeagueNameLabel>
				<M.ToggleCartet active={this.state.open} />
			</M.CategoryButton>
			{this.state.wasOpen && <div class={this.state.open ? "" : "hidden"}>
				{Object.values(category.sub)
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.sort((a, b) => a.order - b.order)
					.map(tournament => (
						<TournamentRow key={tournament.id} tournament={tournament} onTournamentOpen={onTournamentOpen} />
					))}
			</div>}
		</div>
	}
}

function TournamentRow({tournament, onTournamentOpen}) {
	const isOpen = Page.tournamentIsOpen(tournament.id);
	return <M.TournamentButton
		active={isOpen}
		onClick={e => {
			if (isOpen)
				Page.closeTournament(tournament.id)
			else
				Page.openTournaments([tournament.id])
			if (!!onTournamentOpen)
				onTournamentOpen(tournament);
		}}
	>
		<M.CircleSeparatorW3 active={isOpen} />
		<M.TournamentLabel>{tournament.name}</M.TournamentLabel>
		<M.TournamentPlusSign active={isOpen} />
	</M.TournamentButton>
}